/** Picks the comments backend: mock (default) or `/api/v1/comments` (same origin/session as ../index.ts). */
import { useMock } from '../index'
import { HttpCommentsApi } from './http'
import { MockCommentsApi } from './mock'
import type { CommentsApi } from './types'

let current: CommentsApi | null = null

export function getCommentsApi(): CommentsApi {
  if (!current) {
    const base = (import.meta.env.VITE_API_BASE ?? '').trim()
    current = useMock ? new MockCommentsApi() : new HttpCommentsApi(base)
  }
  return current
}

/** Tests inject their own backend. */
export function setCommentsApi(api: CommentsApi | null): void {
  current = api
}

export type * from './types'
